import { CognitoHostedUIIdentityProvider } from '@aws-amplify/auth/lib-esm/types';
import { useEffect, useMemo } from 'react';
import { useTranslation } from 'react-i18next';
import { Link } from 'react-router-dom';

import { Box } from '../../components/Layout';
import { useQueryUrl } from '../../hooks/QueryUrl';
import { useSiteRef } from '../../hooks/SiteRef';
import SymbolKeepoIcon from '../../icons/SymbolKeepo';
import * as authenticationService from '../../services/auth';
import FacebookIcon from './icons/Facebook';
import GoogleIcon from './icons/Google';
import {
    ButtonSocialLogin,
    ButtonsSection,
    Container,
    LogoSection,
    SubTitle,
    Title,
} from './styles';

const valid_actions = ['plus', 'login', 'start'];

const LoginPage = () => {
    const { t } = useTranslation();
    const queryUrl = useQueryUrl();
    const { setRef } = useSiteRef();

    const action = (useQueryUrl().get('action') || 'start').toLowerCase();

    const messages = useMemo(() => {
        const safeAction = valid_actions.includes(action) ? action : 'start';
        return {
            title: t(`pages.login.${safeAction}.title`),
            description: t(`pages.login.${safeAction}.description`),
        };
    }, [action, t]);

    const startFacebookSignIn = () =>
        authenticationService.federatedSignIn(
            CognitoHostedUIIdentityProvider.Facebook
        );

    const startGoogleSignIn = () =>
        authenticationService.federatedSignIn(
            CognitoHostedUIIdentityProvider.Google
        );

    useEffect(() => {
        setRef(queryUrl.get('ref'));
    }, [queryUrl, setRef]);

    return (
        <Container>
            <Box>
                <LogoSection>
                    <SymbolKeepoIcon />
                </LogoSection>
            </Box>
            <Box>
                <Title>{messages.title}</Title>
                <SubTitle>{messages.description}</SubTitle>
            </Box>
            <Box className="npt npb">
                <ButtonsSection>
                    <ButtonSocialLogin
                        type="OUTLINE"
                        size="LG"
                        onClick={() => startFacebookSignIn()}
                    >
                        <FacebookIcon />
                        {t('pages.login.loginButton.facebook')}
                    </ButtonSocialLogin>
                    <ButtonSocialLogin
                        type="OUTLINE"
                        size="LG"
                        onClick={() => startGoogleSignIn()}
                    >
                        <GoogleIcon />
                        {t('pages.login.loginButton.google')}
                    </ButtonSocialLogin>
                </ButtonsSection>
            </Box>
            <Box className="legal">
                <p>
                    {t('pages.login.legal.text')}{' '}
                    <Link to="legal">{t('pages.login.legal.linkText')}</Link>
                </p>
            </Box>
        </Container>
    );
};

export default LoginPage;
